export interface TokenManager {
    /**
     * Check if the current token is about to expire (within 5 minutes)
     */
    isTokenExpiring(): Promise<boolean>;
    
    /**
     * Proactively refresh the token before it expires
     * Returns the new token or throws an error if refresh fails
     */
    refreshToken(): Promise<string>;
    
    /**
     * Get the current access token
     */
    getAccessToken(): Promise<string | null>;
    
    /**
     * Initiate login redirect when token refresh fails
     */
    loginRedirect(): Promise<void>;
    
    /**
     * Check if redirect is currently locked (to prevent infinite redirects)
     */
    isRedirectLocked(): boolean;
    
    /**
     * Lock redirect for a specified duration
     */
    lockRedirect(): void;
}

export const LOCK_DURATION = 5 * 60 * 1000; // 5 minutes
export const LAST_REDIRECT_TIMESTAMP_KEY = 'lastRedirectTimestamp';
export const TOKEN_EXPIRY_BUFFER = 5 * 60 * 1000; // 5 minutes buffer before expiration

export function getLastRedirectTimestamp(): number {
    return parseInt(sessionStorage.getItem(LAST_REDIRECT_TIMESTAMP_KEY) || '0', 10);
}

export function setLastRedirectTimestamp(): void {
    sessionStorage.setItem(LAST_REDIRECT_TIMESTAMP_KEY, Date.now().toString());
}

export function isRedirectLocked(): boolean {
    const lastRedirectTimestamp = getLastRedirectTimestamp();
    return Date.now() - lastRedirectTimestamp < LOCK_DURATION;
}
